import _ from 'lodash';

export const listingAccuracy = (listingAccuracyHistory, listingAccuracyHistoryPeriods, chartType) => {
  // Display a marker if there is only one data point (no line can be made from a single point)
  const series = listingAccuracyHistory.map(periodHistory => {
    const capitalizedString = periodHistory.provider.charAt(0) + periodHistory.provider.substr(1).toLowerCase();
    return ({
      name: capitalizedString,
      data: periodHistory.records.map(record => [Date.parse(record.date), record.value])
    });
  })

  let min = undefined;
  let max = undefined;
  listingAccuracyHistory.forEach(periodHistory => {
    for (let h of periodHistory.records) {
      min = min === undefined ? h.value : Math.min(min, h.value);
      max = max === undefined ? h.value : Math.max(max, h.value);
    }
  })

  min = min || 0;
  max = max || 1;
  min = Math.max(min - 0.1, 0);
  max = Math.min(max + 0.1, 1);


  const config = {
    chart: {
      type: chartType
    },
    title: {
      text: ''
    },
    legend: {
      // squareSymbol: true,
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 6,
    },
    tooltip: {
      formatter: function () {
        return `<span>${this.series.name} - ${Math.round(this.y * 10000) / 100}%</span>`
      },
      useHTML: true
    },
    xAxis: {
      type: 'datetime',
      labels: {
        y: 20,
        enabled: true,
        useHTML:false,
        rotation: 0,
      },
      minorTickLength: 0,
      tickLength: 0,
    },
    yAxis: {
      max: max,
      min: min,
      labels: {
        formatter: function () {
          return Math.ceil(this.value * 100)
        }
      },
      title: {
        text: "Accuracy"
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 4,
        connectNulls: true,
        marker: {
           radius: 4
        },
      },
    },
    series,
  }
  return config
}


export const newListingsCreated = (listingsCreated) => {
  // Display a marker if there is only one data point (no line can be made from a single point)
  let markerEnabled = listingsCreated.length < 2
  const marker = {
    enabled: markerEnabled,
    radius: 5,
    symbol: "circle",
  }

  const series = [{
    name: "New Listings Count",
    marker,
    data: listingsCreated.map(record => [Date.parse(record.date), record.count])
  }]

  const config = {
    chart: {
      marginRight: 30,
      type: 'spline'
    },
    title: {
      text: ''
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        return `<span>${this.y}</span>`
      },
      useHTML: true
    },
    xAxis: {
      type: 'datetime',
      labels: {
        y: 20,
        staggerLines: true,
        enabled: true,
        // formatter: function () {
        //   return `<span class="sentiment-chart-label">${historyPeriods[this.value] || ''}</span>`
        // },
        useHTML:false,
        rotation: 0,
      },
      minorTickLength: 0,
      tickLength: 0,
    },
    yAxis: {
      labels: {
      },
      title: {
        text: null,
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 4,
        connectNulls: true,
        marker: {
          enabled: false,
        },
      },
    },
    series,
  }

  return config
}
